import React from 'react';

const ProfileContext = React.createContext(null);

export default ProfileContext;
